import React from "react";
import { useRangeSelectControl } from "@hooks";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { RangeSelector } from "@rentablo/components";
import { ValuationChart } from "@components/Chart/highcharts";
import { useRecommendationDetails } from "../../RecommendationDetailsProvider";
import { useGetHistoricQuotes } from "../hooks/useGetHistoricQuotes";

export const QuoteComparisonSection = () => {
  const theme = useTheme();
  const { recommendation, investment, names } = useRecommendationDetails();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const { range, intervalType, customIntervalSelect, selectInterval } =
    useRangeSelectControl({
      firstDate: new Date(),
    });
  const { chartData, isFetching, isFetched } = useGetHistoricQuotes(
    range,
    recommendation,
    investment
  );

  return (
    <Box overflow="hidden">
      <Box display="flex" justifyContent="flex-end">
        <Box width="fit-content" mb={3}>
          <RangeSelector
            compact={isXs}
            range={intervalType === "custom" ? range : undefined}
            intervalType={intervalType}
            onSelect={selectInterval}
            onCustomSelect={customIntervalSelect}
          />
        </Box>
      </Box>
      <ValuationChart
        chartData={chartData}
        isFetching={isFetching}
        isFetched={isFetched}
        showInvestedCapitalToggle={false}
        tooltipType="percentage"
        legendCircleSize={8}
        seriesNameMap={{
          totalValues: names.investment,
          comparisonValues: names.recommendation,
        }}
        colors={{
          totalValues: theme.palette.graphVisual["06"].mid,
          comparisonValues: theme.palette.graphVisual["02"].mid,
        }}
        labelStyle={{
          fontSize: "10px",
          lineHeight: "16px",
          fontWeight: "500",
          textTransform: "uppercase",
        }}
      />
    </Box>
  );
};
